import { Loader2 } from 'lucide-react';

export function AuthLoadingScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white">
      <img src="/Flote_Word_Red.png" alt="Flote" className="h-12 mb-6" />
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
